var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-intro-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"block",staticStyle:{"width":"100%"}},[_c('h3',{staticClass:"bold",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }